export const registerModelToJSON = (obj: IRegister): IRegisterJson => {
	const { firstName, lastName, passwordConfirmation, phoneNumber, phoneToken, token, code, ...rest } = obj

	return {
		code: phoneToken,
		first_name: firstName,
		last_name: lastName,
		password_confirmation: passwordConfirmation,
		phone_number: `+${code.dialCode}${phoneNumber.toString()}`,
		invitation_token: token,
		...rest,
	}
}

export const preRegisterFormToJson = (obj: IPreRegisterForm): IPreRegisterFormJson => {
	const { firstName, lastName, phoneNumber, passwordConfirmation, token, code, ...rest } = obj

	return {
		first_name: firstName,
		last_name: lastName,
		password_confirmation: passwordConfirmation,
		phone_number: `+${code.dialCode}${phoneNumber.toString()}`,
		invitation_token: token,
		...rest,
	}
}
